import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { AppScreenTitle, AppTable } from "@/components/common";
import { LangConstant } from "@/const";
import { PaginationType } from "@/types/common";
import useApplicationColumn from "./hooks/useApplicationColumn";
import useApplicationList from "./hooks/useApplicationList";

const ApplicationListPage = () => {
  const [pageData, setPageData] = useState<Partial<PaginationType>>({});

  const { t: getLabel } = useTranslation(LangConstant.NS_APPLICATION);
  const { applicationList, pagination } = useApplicationList(pageData);
  const { columnList } = useApplicationColumn();

  return (
    <Box>
      <AppScreenTitle>{getLabel("L_APPLICATION_MANAGE_TITLE")}</AppScreenTitle>

      <AppTable
        data={applicationList}
        columns={columnList}
        pagination={pagination}
        onChangePagination={setPageData}
        hasCheckbox={false}
        onSelectedRequest={() => {}}
      />
    </Box>
  );
};

export default ApplicationListPage;
